const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const loginUSer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'USER_LOGIN_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'USER_LOGIN_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default loginUSer;